
import  {CalendarPlus, Settings, Report}            from '../../lib/iprs-react-library/src/index.js';

import useBookingState, { B_ACTIONS }               from '../Booking/bookingReducer';
import { PS_REPORT, PS_SETTINGS_SITES }                        from '../App/Reducer';

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

const SideBarTopButtons = ({eventDispatch, state}) => {
    
    const [bookingState, bookingUpdater] = useBookingState(state, eventDispatch)
    
    let bookEnabled         = true;
    let settingsEnabled     = true;
    if( bookingState.pageState ) {
        bookEnabled = false;
    } else if (PS_SETTINGS_SITES === state.pageState) {
        settingsEnabled     = false;
    }
    
    const handleClick = e => {
        
        if( 'booking' === e.target.name ){
            bookingUpdater( B_ACTIONS.MENU_CLICK );
        }else{
            eventDispatch( { menu: e.target.name } );
        }
    }
    
    return <>
        <CalendarPlus onClick={handleClick} name='booking' enabled={bookEnabled}
            value='booking' title={'Make a Booking'} />
        <Report onClick={handleClick} name={PS_REPORT} enabled={true}
            value={PS_REPORT} title={'Reporting'} />
        {<Settings  onClick={handleClick} name='settings' enabled={settingsEnabled}
                    value='settings' title={'Change settings'} />}
    </>
}

export default SideBarTopButtons;


